<script>
// 加载中
import InnerLoading from "@/components/spinner/spinner.vue";
// 动态表单模版
import Temp from '@/components/technician/temp/index'
import {
  processNewdetails,
  processRemove,
  processTaskHistorical,
  processUserUnclaimed,
  // processGeneralsubmit
} from "@/lib/request";
import {getLocalItem} from "@/untils/common";
export default {
  name: 'channelHome',
  data() {
    return {
      roleName:'',
      innerLoading:false,
      activeTab: '西藏-网点维护',
      // 动态表单模版
      returnObj:{},
      formDefine:{},
      flowNameObj:{},
      formFields:[],
      historyList:[],
      flagTemp:false,
      // 列表数据
      page1:1,//当前页
      size1:20,//每页条数
      totals1:0,//总条数
      totalPages1:0,//总页数
      finished1: true,
      loading1:false,
      finishedMsgTxt:'没有更多了',
      inList:[],
    }
  },
  components:{
    InnerLoading,
    Temp
  },
  watch:{
    // 监控参数变化更新游戏列表接口数据
    searchParams:function() {
      this.getListData();
    },
  },
  computed:{
    // 监控参数变化更新游戏列表接口数据
    searchParams() {
      return {
        pageSize:this.size1,//每页数量
        pageNum:this.page1,//当前页码
        category:'',//this.activeTab,
        // openId:this.user_openid,//
        // orderByColumn:'createTime',
        // isAsc:'asc',
        // state:this.activeTab//积分类型
      };
    },
  },
  created() {
    if(getLocalItem('roles')){
      this.roleName = getLocalItem('roles');
    }
    if(this.$route.query.active){
      this.activeTab = this.$route.query.active
    }else{
      // 当前任务列表数据
      this.getListData();
    }
  },
  methods: {
    onLoad() {
      setTimeout(() => {
        if(this.page1<this.totalPages1){
          this.page1 = this.page1+1;
        }
      },1000);
    },
    // 当前任务列表数据
    getListData(){
      this.loading1 = true;
      this.finished1 = false;
      if(this.searchParams.pageNum===1){
        this.inList = [];
      }
      processUserUnclaimed(this.searchParams).then((res)=>{
        if(res){
          if(res.data){
            this.loading1 = false;
            if(res.data.code===200){
              let resData = res.data.data.processBacklogTask
              this.totals1 = res.data.data.total;
              this.totalPages1 = Math.ceil(res.data.data.total / this.size1);
              if (resData == null || resData.length === 0) {
                this.finished1 = true;
                this.inList = [];
                return false;
              } else {
                resData.map((v)=>{
                  if(v.processInstanceName){
                    if(v.processInstanceName.split('-')&&v.processInstanceName.split('-').length>1){
                      v.arr_name = v.processInstanceName.split('-')[1];
                    }else{
                      v.arr_name = v.processInstanceName;
                    }
                  }else if(v.processDefinitionName){
                    if(v.processDefinitionName.split('-')&&v.processDefinitionName.split('-').length>1){
                      v.arr_name = v.processDefinitionName.split('-')[1];
                    }else{
                      v.arr_name = v.processDefinitionName;
                    }
                  }
                });
                if (this.page1 > 1) {
                  this.inList = this.inList.concat(resData);
                } else {
                  this.inList = resData;
                }
                // 总条数和每页条数
                if (this.totals1 < this.size1) {
                  this.finished1 = true;
                  return;
                }
                // 当前页和总页数
                if (this.page1 === this.totalPages1) {
                  this.finished1 = true;
                  return false;
                }
              }
            }else{
              this.$toast.fail(res.data.msg);
            }
          }
        }
      });
    },
    // 查看网点
    getQuerySiteIdInfo(siteId){
      if(siteId){
        this.$router.push({path:'/techSiteId',query:{'siteId':siteId}});
      }else{
        this.$toast('无网点编号');
      }
    },
    // 流程表单提交接口
    getTempReturn(data){
      // processGeneralsubmit(data).then((res)=>{
      //   if(res){
      //     if(res.data){
      //       if(res.data.code===200){
      //         this.$toast(res.data.msg);
              this.formFields = [];
              this.returnObj = {};
              this.formDefine = {};
              this.flagTemp = false;
              this.getListData();
      //       }else{
      //         this.$toast.fail(res.data.msg);
      //       }
      //     }
      //   }
      // });
    },
    // 流程里面做完的流程历史数据
    historyObjectData(processInstanceId){
      processTaskHistorical({
        processInstanceId:processInstanceId,
        handler:false
      }).then((res)=> {
        if (res) {
          if (res.data) {
            if (res.data.code === 200) {
              if(res.data.data.historicActivityInstances&&res.data.data.historicActivityInstances.length>0){
                res.data.data.historicActivityInstances.map((v,k)=>{
                  if(v.formInfo.fields){
                    v.formInfo.fields.map((i,s)=>{
                      if(i.params.customDesign.type==='fileupload'){
                        i.files =  i.value?i.value.split(','):[];
                      }else if(i.params.customDesign.type==='rate'){
                        i.value = parseInt(i.value)/2;
                      }
                    })
                  }
                });
                this.historyList = res.data.data.historicActivityInstances;
              }
            }else{
              this.$toast.fail(res.data.msg);
            }
          }
        }
      });
    },
    // 去处理任务
    getActiveItemInfo(item){
      this.innerLoading = true;
      processNewdetails({
        taskId:item.taskId,
        processInstanceId:item.processInstanceId
      }).then((res)=> {
        if (res) {
          if (res.data) {
            if (res.data.code === 200) {
              if(res.data.data&&res.data.data.variables.processInstanceId){
                this.historyObjectData(res.data.data.variables.processInstanceId);
              }
              this.returnObj = res.data.data;
              this.taskId = item.taskId;
              let formDefine = JSON.parse(res.data.data.formDefine);
              if(formDefine){
                this.formDefine = formDefine;
                if(formDefine.fields.length>0){
                  formDefine.fields.map((v)=>{
                    v.id_name = '';
                    v.showItem = true;
                    if(v.id.indexOf('Name')!==-1){
                      v.id_name = 'name'
                    }else if(v.id.indexOf('name')!==-1){
                      v.id_name = 'name'
                    }else if(v.id.indexOf('phone')!==-1){
                      v.id_name = 'phone'
                    }else if(v.id.indexOf('identity')!==-1){
                      v.id_name = 'identity'
                    }
                    if(v.params.customDesign){
                      if(v.params.customDesign.type==='fileupload'){
                        v.files = [];
                      }else if(v.params.customDesign.type==='rate'){
                        v.socre = 0;
                        v.scoreValue = 0;
                        v.scoreValueFlag = true;
                      } else if (v.params.customDesign.type === 'date') {
                        v.dates = '';
                        v.dateValue = '';
                        v.dateValueFlag = true;
                      } else if (v.params.customDesign.type === 'select') {
                        // 复选框
                        if(v.params.customDesign.multiple){
                          v.checkList = []
                        }
                      }
                    }
                  });
                  // this.flowNameObj = item;
                  this.formFields = formDefine.fields;
                  this.flagTemp = true;
                  this.innerLoading = false;
                }
              }
            }
          }
        }
      });
    },
    // 删除流程-开发人员使用
    getApiDel(item) {
      processRemove({
        processInstanceId: item.processInstanceId
      }).then((res) => {
        if (res) {
          if (res.data) {
            if (res.data.code === 200) {
              this.page1 = 1;
              this.getListData();
            } else {
              this.$toast.fail(res.data.msg);
            }
          }
        }
      });
    },
  }
}
</script>
<template>
  <div class="tech-content">
    <!--    加载中-->
    <inner-loading v-model="innerLoading"></inner-loading>
    <!--    动态表单模版-->
    <Temp v-model="flagTemp" content="close" submitText="提交" :variablesObj="{}" :flowNameObj="flowNameObj" :historyList="historyList" :siteIdObj="{}" :returnObj="returnObj" :formDefine="formDefine" :formFields="formFields" @submit="getTempReturn"></Temp>
<!--    <div class="tabs">-->
<!--      <van-tabs v-model="activeTab" animated swipeable sticky>-->
        <!-- <van-tab title="全部"></van-tab>-->
<!--        <van-tab title="网点维护" name="西藏-网点维护"></van-tab>-->
<!--        <van-tab title="装撤移" name="西藏-装撤移"></van-tab>-->
<!--      </van-tabs>-->
<!--    </div>-->
    <div>
      <van-list v-model="loading1" :finished="finished1" :finished-text="finishedMsgTxt" :immediate-check="false" @load="onLoad">
        <div class="card" v-for="(item,index) in inList" :key="index">
          <div class="card-title">
            {{item.arr_name}}
          </div>
          <div class="card-info">
            <div class="card-info-item">流程进度：{{item.taskName}}</div>
          </div>
          <div class="card-info">
            <div class="card-info-item">网点编号：{{ item.variables.siteid }}</div>
            <div class="card-info-item">地区：{{item.variables.city}}</div>
          </div>
          <div class="card-info">
            <div class="card-info-item" v-if="item.variables&&item.variables.name">姓名：{{ item.variables.name }}</div>
            <div class="card-info-item" v-if="item.variables&&item.variables.phone">电话：{{item.variables.phone}}</div>
          </div>
          <div class="card-footer">
            <div>开始时间：{{item.startTime}}</div>
            <div>
<!--              <button class="btns btn-secondary" v-show="item.variables&&item.variables.siteid" @click="getQuerySiteIdInfo(item.variables.siteid)">查看网点</button>-->
              <button class="btns btn-primary pd" @click="getActiveItemInfo(item)">去处理</button>
<!--              <button class="btns btn-primary pd" v-show="!item.variables.siteid" @click="getApiDel(item)">删除</button>-->
            </div>
          </div>
        </div>
      </van-list>
    </div>
  </div>
</template>
<style scoped lang="scss">
.tech-content{
  padding-top: 120px;
  box-sizing: border-box;
}
</style>